import React from 'react';
import { motion } from 'framer-motion';
export function BrandBanner() {
  return <section className="bg-primary relative z-30 overflow-visible" data-id="element-39">
      {/* Overlapping container — pulls the text up into the hero and down into the next section */}
      <div className="relative -mt-16 md:-mt-24 lg:-mt-32 pb-8 md:pb-12" data-id="element-40">
        <div className="container mx-auto px-6 md:px-12 text-center" data-id="element-41">
          <motion.h2 initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="text-7xl md:text-9xl lg:text-[11rem] xl:text-[14rem] font-serif font-bold text-white leading-none tracking-tighter" data-id="element-42">
            SMITH
            <span className="text-accent font-light italic mx-1 md:mx-2" data-id="element-43">
              &
            </span>
            JENGS
          </motion.h2>
        </div>
      </div>
    </section>;
}